(() => {
  if (customElements.get('decorta-rug-calculator')) return;
  class DecortaRugCalculator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.unit = 'cm';
      this.width = this.querySelector('[data-width]');
      this.length = this.querySelector('[data-length]');
      this.confirm = this.querySelector('[data-confirm]');
      this.quote = this.querySelector('[data-quote]');
      this.units = this.querySelector('[data-unit]');
      this.onInput = () => this.update();
      this.addEventListener('input', this.onInput);
      this.units.addEventListener('change', () => this.changeUnit());
      this.quote.addEventListener('click', event => {
        if (this.quote.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
      this.update();
    }
    changeUnit() {
      this.update();
      this.unit = this.units.value;
      const factor = this.unit === 'in' ? 2.54 : 1;
      for (const [input, axis] of [[this.width, 'width'], [this.length, 'length']]) {
        const value = this.cmValues[axis];
        if (input.value.trim() && Number.isFinite(value)) input.value = (value / factor).toFixed(2);
        this.lastValues[axis] = input.value;
        input.min = (Number(this.dataset[axis + 'Min']) / factor).toFixed(2);
        input.max = (Number(this.dataset[axis + 'Max']) / factor).toFixed(2);
        this.querySelector(`[data-${axis}-range]`).textContent = `${input.min}–${input.max} ${this.unit}`;
      }
      this.querySelectorAll('[data-unit-label]').forEach(label => { label.textContent = this.unit; });
      this.update();
    }
    update() {
      const factor = this.unit === 'in' ? 2.54 : 1;
      this.cmValues ||= {};
      this.lastValues ||= {};
      for (const [input, axis] of [[this.width, 'width'], [this.length, 'length']]) {
        if (this.lastValues[axis] !== input.value) {
          this.cmValues[axis] = Number(input.value) * factor;
          this.lastValues[axis] = input.value;
        }
      }
      const width = this.cmValues.width;
      const length = this.cmValues.length;
      const valid = this.width.value.trim() !== '' && this.length.value.trim() !== '' && Number.isFinite(width) && Number.isFinite(length) && width > 0 && length > 0 && width >= Number(this.dataset.widthMin) - 0.02 && width <= Number(this.dataset.widthMax) + 0.02 && length >= Number(this.dataset.lengthMin) - 0.02 && length <= Number(this.dataset.lengthMax) + 0.02;
      const area = valid ? width * length / 10000 : 0;
      const cents = Math.round(area * Number(this.dataset.rateCents));
      const currency = this.dataset.currency || 'USD';
      const pricePending = this.dataset.pricePending === 'true';
      this.querySelector('[data-error]').hidden = valid;
      this.querySelector('[data-area]').textContent = valid ? `${area.toFixed(2)} m²` : '—';
      this.querySelector('[data-total]').textContent = valid ? (pricePending ? this.dataset.pricePendingLabel : new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100)) : '—';
      const enabled = valid && this.confirm.checked;
      this.quote.setAttribute('aria-disabled', String(!enabled));
      this.quote.tabIndex = enabled ? 0 : -1;
      const estimate = pricePending ? 'To be confirmed by the supplier' : `${currency} ${(cents / 100).toFixed(2)} before delivery and applicable taxes`;
      const body = `${this.dataset.title}\n${this.dataset.url}\n\nWidth: ${this.width.value} ${this.unit}\nLength: ${this.length.value} ${this.unit}\nProduction measurements: ${width.toFixed(2)} × ${length.toFixed(2)} cm\nArea: ${area.toFixed(4)} m²\nRug estimate: ${estimate}\n\nDelivery country:\nPostal code:\n\nPlease confirm availability, final price and delivery.`;
      this.quote.href = `mailto:support@decorta.com?subject=${encodeURIComponent(this.dataset.subject + ': ' + this.dataset.title)}&body=${encodeURIComponent(body)}`;
    }
  }
  customElements.define('decorta-rug-calculator', DecortaRugCalculator);
})();

